import {
  GropuRegisteredCoachScheduleDetail,
  RegisteredCoachScheduleDetail
} from '#types/schedule';
import Divider from 'src/features/ScheduleRegistration/components/Divider';
import MemberLink from './MemberLink';
import * as S from './styles';

interface GroupMemberProps {
  item: GropuRegisteredCoachScheduleDetail;
  data: RegisteredCoachScheduleDetail;
}

const GroupMember = ({ item, data }: GroupMemberProps) => {
  return (
    <div key={item.id}>
      <S.LabeledInfo>
        <S.LabeledInfoTitle>회원</S.LabeledInfoTitle>

        <MemberLink personId={item.personId} id={item.confirmationFormId}>
          {item?.personName}
        </MemberLink>
      </S.LabeledInfo>

      <S.LabeledInfo>
        <S.LabeledInfoTitle>수업</S.LabeledInfoTitle>
        <S.LabeledInfoDescription>{data?.title}</S.LabeledInfoDescription>
      </S.LabeledInfo>

      <S.LabeledInfo>
        <S.LabeledInfoTitle>회차</S.LabeledInfoTitle>
        <S.LabeledInfoDescription>
          {item?.round}/{item?.totalRound}회차
        </S.LabeledInfoDescription>
      </S.LabeledInfo>
      <Divider />
    </div>
  );
};

export default GroupMember;
